import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

/**
 * Текущий раут.
 */

const initialState: any = "";

export const setCurrentPageSlice = createSlice({
  name: "setCurrentPage",
  initialState,
  reducers: {
    setCurrentPageData: (state, action: PayloadAction<string>) => {
      state = action.payload;
      return state;
    },
  },
});

export const { setCurrentPageData } = setCurrentPageSlice.actions;

export default setCurrentPageSlice.reducer;
